export const pageTypes = {
    DASHBOARD: "Dashboard",
    EVENTS: "Events",
    HISTORICAL_SEARCH: "HistoricalSearch",
    SEARCH: "Search",
    SEARCHRESULT: "SearchResult",
    EVENT_INFO: "eventsInfo",
    STATISTICS: "Statistics",
    DEVICES: "Devices",
    CAMERA_INFO: "cameraInfoPage",
    COMPANION_INFO: "companionDeviceInfoPage",
    COMPANION_DEVICE_INFO: "CompanionDeviceInfo",
    CAMERA_ONBOARDING: "cameraOnboarding",
    ROI_LISTING: "roi",
    SETTINGS: "Settings",
    USERSETTINGS: "usersettings",
    RULES: "rules",
    CREATE_RULE : "createRule",
    CREATE_RULE_SUMMARY : "createRuleSummary",
    USER_GROUPS: "userGroups",
    USER_GROUPS_DETAILS: "userGroupsDetails",
    USER_DETAILS: "userdetails",
    SITES: "sites",
    ADD_SITE: "addSite",
    CAMPUS_DETAILS: "campusDetails",
    EDIT_SITE: "editSite",
    ROLES: "roles",
    EDIT_ROLE: "editRole",
    CREATE_ROLE: "createRole",
    SUPPORT: "support",
    ALERTS: "alerts",
    ALERT_DETAILS: "alertdetails",
    CREATE_ALERT: "createalert",
    LICENSES: "licenses",
    LICENSE_DETAILS: "licensedetails",
    CV_APP_SUB: "cvappsub",
    INCIDENTS: "incidents",
    CV_APPS_LICENSETYPE: "cvAppsLicenseType",
    STATDATASOURCE: "statDataSource",
    POLYGON: "polygon",
    MANUAL_CALIBRATION: "manualcalibration",
    ASSISTANT: "Assistant",
    ENROLLED_APPEARANCE: "enrolledappearance",
    APPEARANCE_DEPLOYMENTS: "appearanceDeployments",
    CREATE_APPEARANCE: "createAppearance",
    EDIT_APPEARANCE: "editAppearance",
};